import {
  FaServer,
  FaUserFriends,
  FaMapMarkerAlt,
  FaClipboardList,
  FaBriefcaseMedical
} from "react-icons/fa";
import { IDashboard } from "../route.type";
import DashboardPage from "../../modules/dashboard/pages/dashboard.page";
import { AddProductPage } from "../../modules/product/pages/add-product.page";
import { AllProductsPage } from "../../modules/product/pages/all-products.page";
import AddLocationPage from "../../modules/location/pages/add-location.page";
import { AllLocationsPage } from "../../modules/location/pages/all-locations.page";
import { TransferPage } from "../../modules/stock-operation/pages/transfer.page";
import { InitialInventoryPage } from "../../modules/stock-operation/pages/initial-inventory.page";
import { DemandInventoryPage } from "../../modules/stock-operation/pages/demand-inventory.page";
import LocationInventoryPage from "../../modules/report/pages/location-inventory.page";
import AllOperationPage from "../../modules/report/pages/all-operation.page";
import { RegisterPage } from "../../modules/auth/pages/register.page";
import { UserListPage } from "../../modules/user/pages/user-list.page";
import DailyProductReportPage from "../../modules/report/pages/daily-product-report.page";
import MonthlyProductReportPage from "../../modules/report/pages/monthly-product-report.page";
import LocationOperationsPage from "../../modules/report/pages/location-operations.page";
import OperationDetailsPage from "../../modules/report/pages/all-operation-details.page";
import { PendingOperationPage } from "../../modules/stock-operation/pages/pending-operation.page";
import { AssignUserToLocationPage } from "../../modules/user/pages/assign-user-to-location.page";
import { EditProductPage } from "../../modules/product/pages/edit-product.page";
import ApprovalOperationDetailsPage from "../../modules/stock-operation/pages/approval-operation-details.page";
import { EditLocationPage } from "../../modules/location/pages/edit.location.page";
import { LogoComponent } from "../../branding/logo.component";
import { AssignUserRolePage } from "../../modules/user/pages/assign-user-role.page";
import { DetailProductsPage } from "../../modules/product/pages/detail-product.page";
import { EditTransferPage } from "../../modules/stock-operation/pages/edit-transfer.page";
import InventoryByDatePage from "../../modules/report/pages/inventory-by-date.page";
// import { CustomReportPage } from "../../modules/report/pages/custom-report.page";
// import { CustomReportDetailsComponent } from "../../modules/report/components/custom-report-details.component";
import { VendorSupplyPage } from "../../modules/stock-operation/pages/vendor-supply.page";
import { AdjustmentPage } from "../../modules/stock-operation/pages/adjustment.page";
import { RemoveUserLocationPage } from "../../modules/user/pages/remove-user-location.page";
import { TrashPage } from "../../modules/stock-operation/pages/trash.page";
import { SubstoreInventoryPage } from "../../modules/report/pages/substore.inventory.page";
import { UserProfilePage } from "../../modules/user/pages/user-profile.page";
import { ConsumptionPage } from "../../modules/stock-operation/pages/consumption.page";
import { DistributionPage } from "../../modules/stock-operation/pages/distribution.page";
import { VendorDemandPage } from "../../modules/stock-operation/pages/vendor-demand.page";
import { AllVendorDemandPage } from "../../modules/report/pages/all-vendor-demand.page";
import { AdjustmentReportPage } from "../../modules/report/pages/adjustment-report.page";
import { DemanFulfillPage } from "../../modules/stock-operation/pages/deman-fulfill.page";
import { SingleProductInventoryPage } from "../../modules/report/pages/single-product-inventory.page";
import { SingleProductMovementByLocationPage } from "../../modules/report/pages/single-product-movement-by-location.page";
import { ChangePasswordPage } from "../../modules/auth/pages/change-password.page";
import { AnnualProductReportPage } from "../../modules/report/pages/annual-product-report.page";
import { UpdatePasswordPage } from "../../modules/auth/pages/update-password.page";
import { SingleProductMovementByDatePage } from "../../modules/report/pages/single-product-movement-by-date.page";
import { AllNotificationComponent } from "../../modules/notification/component/all-notification.component";
import { DistributionReportForPrescriptionPage } from "../../modules/report/pages/distribution-report-for-prescription.page";
import { OperationItemEditPage } from "../../modules/stock-operation/pages/operation-item-edit.page";
import { LowStockPage } from "../../modules/dashboard/pages/low-stock.page";
import { ToBeExpiredPage } from "../../modules/dashboard/pages/to-be-expired.page";

export const adminDashboard: IDashboard = {
  dashboardName: "ADMIN",
  logo: <LogoComponent />,
  pages: [
    {
      name: "Dashboard",
      link: "/admin/dashboard",
      content: <DashboardPage />
    },
    {
      name: "All Notification",
      link: "/admin/notification-all",
      content: <AllNotificationComponent />
    },

    {
      name: "Add Product",
      link: "/admin/product/add",
      content: <AddProductPage />
    },
    {
      name: "All Products",
      link: "/admin/all-products",
      content: <AllProductsPage />
    },
    {
      name: "Product Details",
      link: "/admin/product-details/:id",
      content: <DetailProductsPage />
    },
    {
      name: "Add Location",
      link: "/admin/location/create",
      content: <AddLocationPage />
    },
    {
      name: "All Locations",
      link: "/admin/location/summary",
      content: <AllLocationsPage />
    },
    {
      name: "Transfer Operation",
      link: "/admin/stock-operation/transfer/create",
      content: <TransferPage />
    },
    {
      name: "Edit Transfer Operation",
      link: "/admin/stock-operation/transfer/edit/:operationId",
      content: <EditTransferPage />
    },
    {
      name: "Pending Operation",
      link: "/admin/stock-operation/pending-operation",
      content: <PendingOperationPage />
    },
    {
      name: "Initial Inventory",
      link: "/admin/stock-operation/initial-inventory/crete",
      content: <InitialInventoryPage />
    },
    {
      name: "Vendor Supply",
      link: "/admin/stock-operation/vendor-supply/create",
      content: <VendorSupplyPage />
    },
    {
      name: "Vendor Demand",
      link: "/admin/stock-operation/vendor-demand/create",
      content: <VendorDemandPage />
    },
    {
      name: "Trash",
      link: "/admin/stock-operation/trash/create",
      content: <TrashPage />
    },
    {
      name: "Consumption",
      link: "/admin/stock-operation/consumption/create",
      content: <ConsumptionPage />
    },
    {
      name: "Adjustment",
      link: "/admin/stock-operation/adjustment",
      content: <AdjustmentPage />
    },
    {
      name: "Demand Inventory",
      link: "/admin/stock-operation/demand/create",
      content: <DemandInventoryPage />
    },
    {
      name: "Demand Fulfill",
      link: "/admin/demand-fulfil/:id",
      content: <DemanFulfillPage />
    },
    {
      name: "Location Inventory",
      link: "/admin/report/location-inventory",
      content: <LocationInventoryPage />
    },
    {
      name: "Sub Location Inventory",
      link: "/admin/report/sub-location-inventory",
      content: <SubstoreInventoryPage />
    },
    {
      name: "All Operation",
      link: "/admin/report/all-operation",
      content: <AllOperationPage />
    },
    {
      name: "Location Operations",
      link: "/admin/report/location-operations",
      content: <LocationOperationsPage />
    },
    {
      name: "Operation Details",
      link: "/admin/report/operation-details/:id",
      content: <OperationDetailsPage />
    },
    {
      name: "Approval Operation Details",
      link: "/admin/approval/operation-details",
      content: <ApprovalOperationDetailsPage />
    },
    {
      name: "Daily Product Report",
      link: "/admin/report/daily-product-report",
      content: <DailyProductReportPage />
    },
    {
      name: "Monthly Product Report",
      link: "/admin/report/monthly-product-report",
      content: <MonthlyProductReportPage />
    },
    {
      name: "Annual Product Prediction Report",
      link: "/admin/report/annual-product-report",
      content: <AnnualProductReportPage />
    },
    {
      name: "Register User",
      link: "/admin/register",
      content: <RegisterPage />
    },
    {
      name: "User List",
      link: "/admin/user-list",
      content: <UserListPage />
    },
    {
      name: "Assign User Location",
      link: "/admin/assign-user-to-location",
      content: <AssignUserToLocationPage />
    },
    {
      name: "Remove User Location",
      link: "/admin/remove-user-location",
      content: <RemoveUserLocationPage />
    },
    {
      name: "Edit Product",
      link: "/admin/product/edit/:id",
      content: <EditProductPage />
    },
    {
      name: "Edit Location",
      link: "/admin/location/edit/:id",
      content: <EditLocationPage />
    },
    {
      name: "Reset Password",
      link: "/admin/change-password",
      content: <ChangePasswordPage />
    },
    {
      name: "Assign User Role",
      link: "/admin/assign-user-role",
      content: <AssignUserRolePage />
    },
    {
      name: "Inventory By Date",
      link: "/admin/report/previous-inventory",
      content: <InventoryByDatePage />
    },
    // {
    //   name: "Custom Report",
    //   link: "/admin/report/custom-report",
    //   content: <CustomReportPage />
    // },
    // {
    //   name: "Custom Report",
    //   link: "/admin/custom-reports",
    //   content: <CustomReportDetailsComponent />
    // },
    {
      name: "Profile",
      link: "/admin/profile",
      content: <UserProfilePage />
    },
    {
      name: "Distribution",
      link: "/admin/distribution",
      content: <DistributionPage />
    },
    {
      name: "All Vendor Demand",
      link: "/admin/report/all-vendor-demand",
      content: <AllVendorDemandPage />
    },
    {
      name: "Adjustment Report",
      link: "/admin/report/adjustment-report",
      content: <AdjustmentReportPage />
    },
    {
      name: "Single Product Inventory",
      link: "/admin/report/single-product-inventory",
      content: <SingleProductInventoryPage />
    },
    {
      name: "Single Product Movement (By Location)",
      link: "/admin/report/single-product-movement",
      content: <SingleProductMovementByLocationPage />
    },
    {
      name: "Update Password",
      link: "/admin/update-password",
      content: <UpdatePasswordPage />
    },
    {
      name: "Single Product Movement (By Date)",
      link: "/admin/report/date-wise-product-movement",
      content: <SingleProductMovementByDatePage />
    },
    {
      name: "Distribution For Prescription",
      link: "/admin/report/distribution-prescription",
      content: <DistributionReportForPrescriptionPage />
    },
    {
      name: "Edit ",
      link: "/admin/edit/operation-item/",
      content: <OperationItemEditPage />
    },
    {
      name: "Low Stock Products",
      link: "/admin/low-stock",
      content: <LowStockPage />
    },
    {
      name: "Items To Be expired",
      link: "/admin/to-be-expired",
      content: <ToBeExpiredPage />
    }
  ],

  sidebar: [
    {
      name: "Dashboard",
      link: "/admin/dashboard",
      content: <DashboardPage />
    },
    {
      header: "Product",
      icon: FaBriefcaseMedical,
      pages: [
        {
          name: "Add Product",
          link: "/admin/product/add",
          content: <AddProductPage />
        },
        {
          name: "All Products",
          link: "/admin/all-products",
          content: <AllProductsPage />
        }
      ]
    },
    {
      header: "Location",
      icon: FaMapMarkerAlt,
      pages: [
        {
          name: "Add Location",
          link: "/admin/location/create",
          content: <AddLocationPage />
        },
        {
          name: "All Locations",
          link: "/admin/location/summary",
          content: <AllLocationsPage />
        }
      ]
    },
    {
      header: "Stock Operation",
      icon: FaServer,
      pages: [
        {
          name: "Transfer Operation",
          link: "/admin/stock-operation/transfer/create",
          content: <TransferPage />
        },
        {
          name: "Initial Inventory",
          link: "/admin/stock-operation/initial-inventory/crete",
          content: <InitialInventoryPage />
        },
        {
          name: "Vendor Supply",
          link: "/admin/stock-operation/vendor-supply/create",
          content: <VendorSupplyPage />
        },
        {
          name: "Vendor Demand",
          link: "/admin/stock-operation/vendor-demand/create",
          content: <VendorDemandPage />
        },
        {
          name: "Operation Adjustment",
          link: "/admin/stock-operation/adjustment",
          content: <AdjustmentPage />
        },
        {
          name: "Demand Inventory",
          link: "/admin/stock-operation/demand/create",
          content: <DemandInventoryPage />
        },
        {
          name: "Consumption",
          link: "/admin/stock-operation/consumption/create",
          content: <ConsumptionPage />
        },
        {
          name: "Trash",
          link: "/admin/stock-operation/trash/create",
          content: <TrashPage />
        },
        {
          name: "Distribution",
          link: "/admin/distribution",
          content: <DistributionPage />
        },
        {
          name: "Pending Operation",
          link: "/admin/stock-operation/pending-operation",
          content: <PendingOperationPage />
        }
      ]
    },
    {
      header: "Report",
      icon: FaClipboardList,
      pages: [
        {
          name: "All Operation",
          link: "/admin/report/all-operation",
          content: <AllOperationPage />
        },
        {
          name: "Location Operations",
          link: "/admin/report/location-operations",
          content: <LocationOperationsPage />
        },
        {
          name: "Location Inventory",
          link: "/admin/report/location-inventory",
          content: <LocationInventoryPage />
        },
        {
          name: "Sub Location Inventory",
          link: "/admin/report/sub-location-inventory",
          content: <SubstoreInventoryPage />
        },
        {
          name: "Inventory By Date",
          link: "/admin/report/previous-inventory",
          content: <InventoryByDatePage />
        },
        {
          name: "Daily Product Report",
          link: "/admin/report/daily-product-report",
          content: <DailyProductReportPage />
        },
        {
          name: "Monthly Product Report",
          link: "/admin/report/monthly-product-report",
          content: <MonthlyProductReportPage />
        },
        // {
        //   name: "Custom Report",
        //   link: "/admin/report/custom-report",
        //   content: <CustomReportPage />
        // },
        {
          name: "All Vendor Demand",
          link: "/admin/report/all-vendor-demand",
          content: <AllVendorDemandPage />
        },
        {
          name: "Adjustment Report",
          link: "/admin/report/adjustment-report",
          content: <AdjustmentReportPage />
        },
        {
          name: "Single Product Inventory",
          link: "/admin/report/single-product-inventory",
          content: <SingleProductInventoryPage />
        },
        {
          name: "Annual Product Prediction Report",
          link: "/admin/report/annual-product-report",
          content: <AnnualProductReportPage />
        },
        {
          name: "Single Product Movement (By Location)",
          link: "/admin/report/single-product-movement",
          content: <SingleProductMovementByLocationPage />
        },
        {
          name: "Single Product Movement (By Date)",
          link: "/admin/report/date-wise-product-movement",
          content: <SingleProductMovementByDatePage />
        },
        {
          name: "Distribution For Prescription",
          link: "/admin/report/distribution-prescription",
          content: <DistributionReportForPrescriptionPage />
        }
      ]
    },
    {
      header: "Users",
      icon: FaUserFriends,
      pages: [
        {
          name: "Profile",
          link: "/admin/profile",
          content: <UserProfilePage />
        },
        {
          name: "Register User",
          link: "/admin/register",
          content: <RegisterPage />
        },
        {
          name: "User List",
          link: "/admin/user-list",
          content: <UserListPage />
        },
        {
          name: "Assign User Location",
          link: "/admin/assign-user-to-location",
          content: <AssignUserToLocationPage />
        },
        {
          name: "Remove User Location",
          link: "/admin/remove-user-location",
          content: <RemoveUserLocationPage />
        },
        {
          name: "Assign User Role",
          link: "/admin/assign-user-role",
          content: <AssignUserRolePage />
        },
        {
          name: "Edit",
          link: "/admin/edit/operation-item/",
          content: <OperationItemEditPage />
        }
      ]
    }
  ]
};
